import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {countDownStartNum} from '../helpers/pointScoring'
import { getDatabase, ref, update} from 'firebase/database';
import _ from 'lodash';

export const writeUserLeaderboardDataAsync = createAsyncThunk(
    'timer/writeUserLeaderboardData',
    async ({uid, payload}, { rejectWithValue }) => {
        try {
            const db = getDatabase();
            const dbpayload = {
                totalPlayTime: payload.totalPlayTime,
                date: new Date().toISOString().split('T')[0]
            };
            await update(ref(db, '/users/' + uid + '/leaderBoard'), {...dbpayload});
            return dbpayload;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Legacy functions for backward compatibility
function writeUserTimerData(payload) {
    const db = getDatabase();
    const toWrite = _.omit(payload.data, 'loaded')
    update(ref(db, '/users/' + payload.uid + '/timer'), {
        ...toWrite
    });
}

function writeUserLeaderboardData(uid, payload) {
    const db = getDatabase();
    const dbpayload = {
        totalPlayTime: payload.totalPlayTime,
        date: new Date().toISOString().split('T')[0]
    };
    update(ref(db, '/users/' + uid + '/leaderBoard'), {...dbpayload});
}

export const timerSlice = createSlice({
    name: 'timer',
    initialState: {
        value: 0,
        playingStartDateTime: 0, //this is a date for when the timer starts; total time equals current date time minus playingStartDateTime plus playTimeFromBeforePause
        playTimeFromBeforePause: 0,
        status: false, //true is running, false is paused
        countDownStartNum: countDownStartNum,
        loaded: false,
        gameStarted: false,
        gameDone: false,
        writeLeaderboardLoading: false,
        writeLeaderboardError: null
    },

    reducers: {
        endTimer: (state, action) => {
            //conditional statement needed in case of re-renders to avoid the double counting
            if (state.gameDone) {
                return
            }
            const additionalTime = new Date().getTime() / 1000 - state.playingStartDateTime;
            const totalPlayTime = Math.floor(state.playTimeFromBeforePause + additionalTime)
            state.playTimeFromBeforePause += additionalTime;
            state.status = false;
            state.gameDone = true;
            const payload = {totalPlayTime};
            const {uid} = action.payload;
            writeUserLeaderboardData(uid, payload);
        },
        initTimer: (state, action) => {
            const {uid, playingStartDateTime} = action.payload;
            state.playingStartDateTime = playingStartDateTime || new Date().getTime() / 1000;
            state.loaded = true
            writeUserTimerData({uid, data: state})
        },
        timerReset: (state) => {
            state.value = 0;
            state.playingStartDateTime = 0;
            state.playTimeFromBeforePause = 0;
            state.status = false
        },
        setTimerStatus: (state, action) => {
            state.status = action.payload;
        },
        clearErrors: (state) => {
            state.writeLeaderboardError = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(writeUserLeaderboardDataAsync.pending, (state) => {
                state.writeLeaderboardLoading = true;
                state.writeLeaderboardError = null;
            })
            .addCase(writeUserLeaderboardDataAsync.fulfilled, (state) => {
                state.writeLeaderboardLoading = false;
            })
            .addCase(writeUserLeaderboardDataAsync.rejected, (state, action) => {
                state.writeLeaderboardLoading = false;
                state.writeLeaderboardError = action.payload;
            });
    }
});

// Action creators are generated for each case reducer function
export const {initTimer, timerReset, endTimer, setTimerStatus, clearErrors} = timerSlice.actions;

export default timerSlice.reducer
